<div class="emoji-container" [style.--emoji-category-height.px]="categoryHeaderHeight()">
  <div class="emoji-top-container">
    <div
      class="emoji-search-container"
      [ngClass]="{ active: activeTop() === 'search-container' }"
      [ngStyle]="{
        'box-shadow': primeThemeService.isDarkMode()
          ? '0.5rem 0.5rem 0.625rem rgba(12, 12, 13, 0.56), -0.5rem -0.75rem 1.25rem rgba(255, 255, 255, 0.08)'
          : '-0.75rem -0.75rem 1.25rem rgba(255, 255, 255, 0.8), 0.625rem 0 0.9375rem rgba(166, 180, 200, 0.7), 0 0 0 1px rgba(0, 0, 0, 0.1)'
      }"
      (click)="setActiveTop('search-container', true)"
      (keydown.enter)="setActiveTop('search-container', true)"
    >
      @if (searchString().length === 0) {
        <i class="emoji-search-icon mi2-search text-base opacity-60"></i>
      }
      @if (searchString().length > 0) {
        <button
          class="emoji-search-icon undo-search-icon"
          [ngClass]="{ active: activeTop() === 'search-container' }"
          [attr.aria-label]="'cl_chat.emoji.clear' | translate"
          (click)="undoSearch()"
        >
          <i class="mi2-close text-base opacity-60"></i>
        </button>
      }
      <input
        #emojiSearchInput
        id="emojiSearchInput"
        type="search"
        [attr.aria-label]="'cl_chat.emoji.searchEmojis' | translate"
        [placeholder]="'cl_chat.emoji.searchEmojis' | translate"
        class="emoji-search"
        [ngClass]="{ active: activeTop() === 'search-container' }"
        [(ngModel)]="searchModel"
        (input)="updateSearchString()"
      />
    </div>
    <div
      class="emoji-skin-tones-container"
      [ngClass]="{ active: activeTop() === 'skin-tones-container' }"
      [ngStyle]="{
        'box-shadow': primeThemeService.isDarkMode()
          ? '0.5rem 0.5rem 0.625rem rgba(12, 12, 13, 0.56), -0.25rem -0.75rem 1.25rem rgba(255, 255, 255, 0.08)'
          : '0.5rem 0.5rem 0.9375rem rgba(166, 180, 200, 0.72), -0.5rem -0.5rem 1rem rgba(255, 255, 255, 0.72)'
      }"
    >
      <div class="emoji-skin-tone-container">
        <div
          id="emoji-skin-tone-selector"
          class="emoji-skin-tone-selector"
          [ngClass]="{ hidden: activeTop() === 'skin-tones-container' }"
          (click)="setActiveTop('skin-tones-container')"
          tabindex="0"
          role="button"
          [attr.aria-expanded]="activeTop() === 'skin-tones-container'"
          [attr.aria-label]="'cl_chat.emoji.skin' | translate"
          (keydown.enter)="setActiveTop('skin-tones-container')"
          (keydown.space)="$event.preventDefault(); setActiveTop('skin-tones-container')"
        >
          <span
            class="active-skin-tone-emoji"
            [innerHTML]="enableTwemoji() ? (activeSkinToneEmoji() | emoji) : unifiedToNative(activeSkinToneEmoji())"
          ></span>
          <span class="active-skin-tone-text">
            {{ 'cl_chat.emoji.skin' | translate }}
          </span>
        </div>
        <div>
          <div
            class="emoji-skin-tone"
            [ngClass]="{
              hidden: activeTop() !== 'skin-tones-container',
              'emoji-skin-tone-list': activeTop() === 'skin-tones-container',
              'select-emoji-skin-tone': activeSkinTone() === 0
            }"
            (click)="setActiveSkinTone(0)"
            tabindex="0"
            role="button"
            [attr.aria-label]="'cl_chat.emoji.skinTones.0' | translate"
            [attr.aria-pressed]="activeSkinTone() === 0"
            (keydown.enter)="setActiveSkinTone(0)"
            (keydown.space)="$event.preventDefault(); setActiveSkinTone(0)"
            [innerHTML]="enableTwemoji() ? ('1F44D' | emoji) : '👍'"
          ></div>
          <div
            class="emoji-skin-tone"
            [ngClass]="{
              hidden: activeTop() !== 'skin-tones-container',
              'emoji-skin-tone-list': activeTop() === 'skin-tones-container',
              'select-emoji-skin-tone': activeSkinTone() === 1
            }"
            (click)="setActiveSkinTone(1)"
            tabindex="0"
            role="button"
            [attr.aria-label]="'cl_chat.emoji.skinTones.1' | translate"
            [attr.aria-pressed]="activeSkinTone() === 1"
            (keydown.enter)="setActiveSkinTone(1)"
            (keydown.space)="$event.preventDefault(); setActiveSkinTone(1)"
            [innerHTML]="enableTwemoji() ? ('1F44D-1F3FB' | emoji) : '👍🏻'"
          ></div>
          <div
            class="emoji-skin-tone"
            [ngClass]="{
              hidden: activeTop() !== 'skin-tones-container',
              'emoji-skin-tone-list': activeTop() === 'skin-tones-container',
              'select-emoji-skin-tone': activeSkinTone() === 2
            }"
            (click)="setActiveSkinTone(2)"
            tabindex="0"
            role="button"
            [attr.aria-label]="'cl_chat.emoji.skinTones.2' | translate"
            [attr.aria-pressed]="activeSkinTone() === 2"
            (keydown.enter)="setActiveSkinTone(2)"
            (keydown.space)="$event.preventDefault(); setActiveSkinTone(2)"
            [innerHTML]="enableTwemoji() ? ('1F44D-1F3FC' | emoji) : '👍🏼'"
          ></div>
          <div
            class="emoji-skin-tone"
            [ngClass]="{
              hidden: activeTop() !== 'skin-tones-container',
              'emoji-skin-tone-list': activeTop() === 'skin-tones-container',
              'select-emoji-skin-tone': activeSkinTone() === 3
            }"
            (click)="setActiveSkinTone(3)"
            tabindex="0"
            role="button"
            [attr.aria-label]="'cl_chat.emoji.skinTones.3' | translate"
            [attr.aria-pressed]="activeSkinTone() === 3"
            (keydown.enter)="setActiveSkinTone(3)"
            (keydown.space)="$event.preventDefault(); setActiveSkinTone(3)"
            [innerHTML]="enableTwemoji() ? ('1F44D-1F3FD' | emoji) : '👍🏽'"
          ></div>
          <div
            class="emoji-skin-tone"
            [ngClass]="{
              hidden: activeTop() !== 'skin-tones-container',
              'emoji-skin-tone-list': activeTop() === 'skin-tones-container',
              'select-emoji-skin-tone': activeSkinTone() === 4
            }"
            (click)="setActiveSkinTone(4)"
            tabindex="0"
            role="button"
            [attr.aria-label]="'cl_chat.emoji.skinTones.4' | translate"
            [attr.aria-pressed]="activeSkinTone() === 4"
            (keydown.enter)="setActiveSkinTone(4)"
            (keydown.space)="$event.preventDefault(); setActiveSkinTone(4)"
            [innerHTML]="enableTwemoji() ? ('1F44D-1F3FE' | emoji) : '👍🏾'"
          ></div>
          <div
            class="emoji-skin-tone"
            [ngClass]="{
              hidden: activeTop() !== 'skin-tones-container',
              'emoji-skin-tone-list': activeTop() === 'skin-tones-container',
              'select-emoji-skin-tone': activeSkinTone() === 5
            }"
            (click)="setActiveSkinTone(5)"
            tabindex="0"
            role="button"
            [attr.aria-label]="'cl_chat.emoji.skinTones.5' | translate"
            [attr.aria-pressed]="activeSkinTone() === 5"
            (keydown.enter)="setActiveSkinTone(5)"
            (keydown.space)="$event.preventDefault(); setActiveSkinTone(5)"
            [innerHTML]="enableTwemoji() ? ('1F44D-1F3FF' | emoji) : '👍🏿'"
          ></div>
        </div>
      </div>
    </div>
  </div>
  @if (activeTop() === 'skin-tones-container') {
    <div class="choose-active-skin-tone">
      {{ 'cl_chat.emoji.chooseDefaultSkinTone' | translate }}
    </div>
  }
  <div
    #emojiScroller
    id="emoji-scroller"
    class="emoji-scroller"
    [ngClass]="{ hidden: activeSearchResults() === true }"
    (keydown)="onEmojiGridKeydown($event)"
    (focusin)="onEmojiGridFocusIn($event)"
  >
    <section
      #categoryContainer
      class="emoji-category-container"
      [ngClass]="{
        hidden: activeSearchResults() === true || frequentlyUsed() === false
      }"
    >
      <div #categoryTopLevel id="emoji-recent-top-level" class="emoji-category-top-level"></div>
      <div #categoryHeader id="emoji-recent-label" class="emoji-category">
        {{ 'cl_chat.emoji.categories.recent' | translate }}
      </div>
      <ul
        #categoryReference
        id="emoji-recent"
        class="emoji-preview-container"
        role="listbox"
        [attr.aria-labelledby]="'emoji-recent-label'"
      >
        @for (emoji of frequentlyUsedEmojis(); track emoji) {
          <li
            class="emoji-preview"
            role="option"
            tabindex="-1"
            [innerHTML]="enableTwemoji() ? (emoji.emojiString | emoji) : unifiedToNative(emoji.emojiString)"
            (click)="onEmojiClick(emoji.emojiString, $event)"
            (keydown.enter)="onEmojiClick(emoji.emojiString, $event)"
          ></li>
        }
      </ul>
    </section>
    @for (category of categoriesList(); track categoryTrack($index, category)) {
      <section
        #categoryContainer
        class="emoji-category-container"
        [ngClass]="{ hidden: activeSearchResults() === true }"
      >
        <div #categoryTopLevel id="emoji-{{ category.id }}-top-level" class="emoji-category-top-level"></div>
        <div #categoryHeader id="emoji-{{ category.id }}-label" class="emoji-category">
          {{ 'cl_chat.emoji.categories.' + category.id | translate }}
        </div>
        <ul
          #categoryReference
          id="emoji-{{ category.id }}"
          class="emoji-preview-container"
          role="listbox"
          [attr.aria-labelledby]="'emoji-' + category.id + '-label'"
        >
          @for (emoji of category.emojis; track trackById($index, emoji)) {
            <li
              class="emoji-preview"
              role="option"
              [innerHTML]="enableTwemoji() ? (emoji.unified | emoji) : emoji.native"
              (click)="onEmojiClick(emoji.unified, $event)"
              tabindex="-1"
              (keydown.enter)="onEmojiClick(emoji.unified, $event)"
            ></li>
          }
        </ul>
      </section>
    }
  </div>
  <div
    #emojiSearchResultsContainer
    id="emoji-search-results-container"
    class="emoji-search-results-container"
    [ngClass]="{ hidden: activeSearchResults() === false }"
    (keydown)="onEmojiGridKeydown($event)"
    (focusin)="onEmojiGridFocusIn($event)"
  >
    <section class="emoji-category-container" [ngClass]="{ hidden: activeSearchResults() === false }">
      <div #categoryHeader id="emoji-search-results" class="emoji-category">
        {{ 'cl_chat.emoji.categories.search' | translate }}
      </div>
      <ul
        class="emoji-preview-container"
        role="listbox"
        aria-labelledby="emoji-search-results"
        [ngClass]="{ hidden: noResults() === true }"
      >
        @for (emojiUnicode of searchResults(); track emojiUnicode) {
          <li
            tabindex="-1"
            role="option"
            class="emoji-preview"
            [innerHTML]="enableTwemoji() ? (emojiUnicode | emoji) : unifiedToNative(emojiUnicode)"
            (click)="onEmojiClick(emojiUnicode, $event)"
            (keydown.enter)="onEmojiClick(emojiUnicode, $event)"
          ></li>
        }
      </ul>
      <div class="emoji-preview-container" [ngClass]="{ hidden: noResults() === false }">
        <div class="no-search-results-container">
          {{ 'cl_chat.emoji.notfound' | translate }}
        </div>
      </div>
    </section>
  </div>
  <div
    #emojiBottomContainer
    id="emoji-anchors"
    class="emoji-bottom-container"
    [ngStyle]="{
      'box-shadow': primeThemeService.isDarkMode()
        ? '0.5rem 0.5rem 1.5rem rgba(12, 12, 13, 0.56),  -0.5rem -0.5rem 1rem rgba(255, 255, 255, 0.08)'
        : '0.5rem 0.5rem 1.5rem rgba(166, 180, 200, 0.72), -0.5rem -0.5rem 1rem rgba(255, 255, 255, 0.72)'
    }"
  >
    <div class="emoji-category-icon">
      <a
        #linkToCategoryTopLevel
        id="link-to-emoji-recent"
        [attr.aria-label]="
          'cl_chat.emoji.jumpToCategory' | translate: { category: ('cl_chat.emoji.categories.recent' | translate) }
        "
        (click)="jumpToCategory('emoji-recent-top-level')"
        tabindex="0"
        (keydown.enter)="jumpToCategory('emoji-recent-top-level')"
      >
        <svg height="24" viewBox="0 -1 24 24" width="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M8 15.75A7.75 7.75 0 1 1 8 .25a7.75 7.75 0 0 1 0 15.5zm0-1.5a6.25 6.25 0 1 0 0-12.5 6.25 6.25 0 0 0 0 12.5zm.75-6.56l2.78 2.78a.75.75 0 0 1-1.06 1.06l-3-3A.75.75 0 0 1 7.25 8V3a.75.75 0 0 1 1.5 0v4.69z"
          ></path>
        </svg>
      </a>
    </div>
    <div class="emoji-category-icon">
      <a
        #linkToCategoryTopLevel
        id="link-to-emoji-people"
        [attr.aria-label]="
          'cl_chat.emoji.jumpToCategory' | translate: { category: ('cl_chat.emoji.categories.people' | translate) }
        "
        (click)="jumpToCategory('emoji-people-top-level')"
        tabindex="0"
        (keydown.enter)="jumpToCategory('emoji-people-top-level')"
      >
        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M11.985 10.696a.4.4 0 1 1 .697.392c-.94 1.674-2.692 2.691-4.663 2.691-2.034 0-3.79-.99-4.704-2.687a.4.4 0 0 1 .704-.38c.77 1.431 2.253 2.267 4 2.267 1.683 0 3.167-.862 3.966-2.283zM14.8 8.892a6.8 6.8 0 1 0-13.6 0 6.8 6.8 0 0 0 13.6 0zm1.2-.067a8 8 0 1 1-16 0 8 8 0 0 1 16 0zM6.4 6.692a1.4 1.4 0 1 1-2.8-.001 1.4 1.4 0 0 1 2.8 0zm3.2 0a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0z"
          ></path>
        </svg>
      </a>
    </div>
    <div class="emoji-category-icon">
      <a
        #linkToCategoryTopLevel
        id="link-to-emoji-nature"
        [attr.aria-label]="
          'cl_chat.emoji.jumpToCategory' | translate: { category: ('cl_chat.emoji.categories.nature' | translate) }
        "
        (click)="jumpToCategory('emoji-nature-top-level')"
        tabindex="0"
        (keydown.enter)="jumpToCategory('emoji-nature-top-level')"
      >
        <svg height="24" viewBox="0 0 20 24" width="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M5.25 9.26V7.5a.75.75 0 0 1 1.5 0v4.25H9c.909 0 1.564-1.224 1.11-2.272L7.08 3.02a1.141 1.141 0 0 0-2.16 0l-.03.076L1.9 9.458c-.465 1.067.19 2.292 1.1 2.292h2.25v-.987a2.076 2.076 0 0 1-1.992-2.368.75.75 0 0 1 1.484.21.577.577 0 0 0 .508.655zm3.946 3.983a3.115 3.115 0 0 1-2.446 2.452v.805a.75.75 0 1 1-1.5 0v-1.493V13.25H3c-2.065 0-3.345-2.392-2.467-4.41L3.517 2.49A2.64 2.64 0 0 1 5.142.893c1.38-.474 2.882.26 3.325 1.565l3.01 6.402c.839 1.936-.333 4.237-2.28 4.383zm-1.56.007H6.75v.886c.399-.163.721-.482.885-.886z"
          ></path>
        </svg>
      </a>
    </div>
    <div class="emoji-category-icon">
      <a
        #linkToCategoryTopLevel
        id="link-to-emoji-foods"
        [attr.aria-label]="
          'cl_chat.emoji.jumpToCategory' | translate: { category: ('cl_chat.emoji.categories.foods' | translate) }
        "
        (click)="jumpToCategory('emoji-foods-top-level')"
        tabindex="0"
        (keydown.enter)="jumpToCategory('emoji-foods-top-level')"
      >
        <svg height="24" viewBox="0 0 21 24" width="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M.935 10.448L.252 6.1a1.256 1.256 0 0 1 1.17-1.349L1.5 4.75h6.085l.358-1.789A2.75 2.75 0 0 1 10.639.75H13a.75.75 0 1 1 0 1.5h-2.36c-.597 0-1.11.42-1.227 1.005L9.115 4.75h2.262c.69 0 1.25.56 1.25 1.25-.001.058-.001.058-.01.148l-.624 4.33a.747.747 0 0 1-.004.028l-.744 5.164a1.75 1.75 0 0 1-1.742 1.58H3.496c-.91 0-1.669-.699-1.737-1.55l-.815-5.193a.748.748 0 0 1-.01-.06zm1.405-.705c.595.054 1.19-.2 1.56-.693.3-.4.9-.4 1.2 0a1.752 1.752 0 0 0 1.485.698l.7-3.498H1.792l.548 3.493zm.237 1.506l.67 4.272a.25.25 0 0 0 .249.229h6.007c.13 0 .239-.1.25-.23l.005-.044.61-4.229a3.258 3.258 0 0 1-1.867-.685 3.23 3.23 0 0 1-.625.383l-.64 3.202a.75.75 0 0 1-1.471-.294l.521-2.61a3.234 3.234 0 0 1-1.786-.681c-.552.43-1.228.67-1.923.687zm8.006-1.5l.505-3.499H8.815L8.31 8.774a.749.749 0 0 1 .79.275c.354.472.913.726 1.483.7z"
          ></path>
        </svg>
      </a>
    </div>
    <div class="emoji-category-icon">
      <a
        #linkToCategoryTopLevel
        id="link-to-emoji-activity"
        [attr.aria-label]="
          'cl_chat.emoji.jumpToCategory' | translate: { category: ('cl_chat.emoji.categories.activity' | translate) }
        "
        (click)="jumpToCategory('emoji-activity-top-level')"
        tabindex="0"
        (keydown.enter)="jumpToCategory('emoji-activity-top-level')"
      >
        <svg height="24" viewBox="1 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M6.084 11.99L5.04 8.77 3.96 8.24 2.307 9.883c.109.83.368 1.611.75 2.318l2.496.383.53-.594zm1.182.93l-.53.591L7.78 15.64a6.789 6.789 0 0 0 2.44 0l1.043-2.129-.529-.592H7.266zm-2.884 1.003c.413.387.875.724 1.375.999l-.417-.852-.958-.147zm7.534-1.932l.531.594 2.497-.383c.381-.707.64-1.489.749-2.318L14.04 8.24l-1.082.53-1.043 3.222zM5.581 7.364l2.669-1.94V4.398L6.06 2.922a6.77 6.77 0 0 0-1.946 1.421L4.49 6.83l1.09.534zM2.375 7.7l.635-.633-.137-.903A6.7 6.7 0 0 0 2.375 7.7zm-1.6 1.953a8.253 8.253 0 0 1 5.086-8.285A8.225 8.225 0 0 1 9 .75a8.225 8.225 0 0 1 3.171.632A8.253 8.253 0 0 1 9 17.25 8.25 8.25 0 0 1 .775 9.653zM13.51 6.83l.377-2.487a6.77 6.77 0 0 0-1.946-1.42L9.75 4.398v1.024l2.669 1.94 1.09-.533zm2.116.87a6.7 6.7 0 0 0-.498-1.536l-.137.903.635.633zm-2.007 6.223l-.958.147-.417.852c.5-.275.962-.612 1.375-1zm-3.5-11.58a6.796 6.796 0 0 0-2.236 0L9 3.095l1.118-.754zm-2.642 9.076h3.048l.938-2.896L9 6.733l-2.462 1.79.938 2.896z"
          ></path>
        </svg>
      </a>
    </div>
    <div class="emoji-category-icon">
      <a
        #linkToCategoryTopLevel
        id="link-to-emoji-places"
        [attr.aria-label]="
          'cl_chat.emoji.jumpToCategory' | translate: { category: ('cl_chat.emoji.categories.places' | translate) }
        "
        (click)="jumpToCategory('emoji-places-top-level')"
        tabindex="0"
        (keydown.enter)="jumpToCategory('emoji-places-top-level')"
      >
        <svg height="22" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M12.75 14.75h.886a.614.614 0 0 0 .476-1.001L9.418 7.973A.75.75 0 0 1 9.25 7.5v-3c0-1.191-.681-2.25-1.25-2.25S6.75 3.309 6.75 4.5v3a.75.75 0 0 1-.168.473l-4.694 5.776a.614.614 0 0 0 .476 1.001h.886v-.25a.75.75 0 1 1 1.5 0v.25H7a.75.75 0 0 1 .75.75.25.25 0 0 0 .5 0 .75.75 0 0 1 .75-.75h2.25v-.25a.75.75 0 1 1 1.5 0v.25zm0 1.5v.25a.75.75 0 1 1-1.5 0v-.25H9.581a1.75 1.75 0 0 1-3.162 0H4.75v.25a.75.75 0 1 1-1.5 0v-.25h-.886a2.115 2.115 0 0 1-1.64-3.447l4.526-5.57V4.5C5.25 2.583 6.43.75 8 .75s2.75 1.833 2.75 3.75v2.734l4.527 5.57a2.115 2.115 0 0 1-1.641 3.446h-.886zM7.25 4.5a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-1.5 0v-3zm-.5 8a.75.75 0 1 1-1.5 0v-2a.75.75 0 1 1 1.5 0v2zm4 0a.75.75 0 1 1-1.5 0v-2a.75.75 0 1 1 1.5 0v2z"
          ></path>
        </svg>
      </a>
    </div>
    <div class="emoji-category-icon">
      <a
        #linkToCategoryTopLevel
        id="link-to-emoji-objects"
        [attr.aria-label]="
          'cl_chat.emoji.jumpToCategory' | translate: { category: ('cl_chat.emoji.categories.objects' | translate) }
        "
        (click)="jumpToCategory('emoji-objects-top-level')"
        tabindex="0"
        (keydown.enter)="jumpToCategory('emoji-objects-top-level')"
      >
        <svg height="24" viewBox="0 0 20 24" width="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M6 7.94l.97-.97a.75.75 0 0 1 1.06 1.06L6.75 9.31v1.374A4.251 4.251 0 0 0 6 2.25a4.25 4.25 0 0 0-.75 8.434V9.311L3.97 8.03A.75.75 0 0 1 5.03 6.97l.97.97zm.75 8.31v.25a.75.75 0 1 1-1.5 0v-.25H4a.75.75 0 1 1 0-1.5h4a.75.75 0 1 1 0 1.5H6.75zM6 .75a5.75 5.75 0 1 1 0 11.5A5.75 5.75 0 0 1 6 .75zm-2 13.5a.75.75 0 1 1 0-1.5h4a.75.75 0 1 1 0 1.5H4z"
          ></path>
        </svg>
      </a>
    </div>
    <div class="emoji-category-icon">
      <a
        #linkToCategoryTopLevel
        id="link-to-emoji-symbols"
        [attr.aria-label]="
          'cl_chat.emoji.jumpToCategory' | translate: { category: ('cl_chat.emoji.categories.symbols' | translate) }
        "
        (click)="jumpToCategory('emoji-symbols-top-level')"
        tabindex="0"
        (keydown.enter)="jumpToCategory('emoji-symbols-top-level')"
      >
        <svg height="24" viewBox="1 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M12.25 8.75h-1a2.497 2.497 0 0 1-2.278-3.53 2.494 2.494 0 0 1 1.601-1.374 2.5 2.5 0 1 1 4.855-.005 2.5 2.5 0 0 1-.68 4.909h-.998V9a.75.75 0 1 1-1.5 0v-.25zm.753-1.5h1.75a1 1 0 1 0-.41-1.91c-.823.378-1.486-.755-.754-1.288a1 1 0 1 0-1.177 0c.73.532.07 1.663-.752 1.29a.999.999 0 1 0-.41 1.908h1.747a.765.765 0 0 1 .006 0zM4.25 16.057a2.563 2.563 0 0 1-3.229-1.137 2.36 2.36 0 0 1 .47-2.818l2.428-2.41.006-.006c.6-.581 1.55-.581 2.156.006l2.411 2.393c.103.094.195.197.277.305.035-.282.121-.562.26-.827a2.563 2.563 0 0 1 3.968-.64 2.563 2.563 0 0 1 3.979.659 2.36 2.36 0 0 1-.47 2.817l-2.425 2.41-.006.005c-.6.581-1.55.581-2.156-.005l-2.411-2.392a2.37 2.37 0 0 1-.277-.306c-.035.282-.121.562-.26.827a2.564 2.564 0 0 1-3.221 1.117v.445a.75.75 0 1 1-1.5 0v-.443zm1.266-2.056l.487.46a1.06 1.06 0 0 0 1.649-.238.876.876 0 0 0-.198-1.056l-2.423-2.405a.044.044 0 0 0-.06 0l-2.442 2.422a.863.863 0 0 0-.19 1.02 1.063 1.063 0 0 0 1.656.26l.488-.462a.75.75 0 0 1 1.033 0zm9.952-.684a.863.863 0 0 0 .19-1.02 1.063 1.063 0 0 0-1.656-.26l-.488.463a.75.75 0 0 1-1.033 0l-.484-.46a1.06 1.06 0 0 0-1.649.238.876.876 0 0 0 .197 1.056l2.424 2.404a.044.044 0 0 0 .06 0l2.439-2.421zM5.569 8.988a.75.75 0 0 1-1.138 0l-3-3.5a.75.75 0 0 1 0-.976l3-3.5a.75.75 0 0 1 1.138 0l3 3.5a.75.75 0 0 1 0 .976l-3 3.5zM7.012 5L5 2.652 2.988 5 5 7.348 7.012 5z"
          ></path>
        </svg>
      </a>
    </div>
    <div class="emoji-category-icon">
      <a
        #linkToCategoryTopLevel
        id="link-to-emoji-flags"
        [attr.aria-label]="
          'cl_chat.emoji.jumpToCategory' | translate: { category: ('cl_chat.emoji.categories.flags' | translate) }
        "
        (click)="jumpToCategory('emoji-flags-top-level')"
        tabindex="0"
        (keydown.enter)="jumpToCategory('emoji-flags-top-level')"
      >
        <svg height="22" viewBox="0 0 24 24" width="22" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M.75 12.822V3.447 1.5a.75.75 0 0 1 1.5 0v.915l1.132-.348a7.157 7.157 0 0 1 5.856.745 5.66 5.66 0 0 0 4.52.622l1.584-.453a1.5 1.5 0 0 1 1.908 1.444v7.818a1.5 1.5 0 0 1-1.088 1.442l-1.992.57a7.16 7.16 0 0 1-5.718-.79 5.657 5.657 0 0 0-4.629-.59l-1.573.484V16.5a.75.75 0 1 1-1.5 0v-3.678zm1.5-8.838v7.806l1.132-.348a7.157 7.157 0 0 1 5.857.745 5.66 5.66 0 0 0 4.52.625l1.991-.57V4.427v-.001l-1.58.45a7.16 7.16 0 0 1-5.718-.786 5.657 5.657 0 0 0-4.63-.588l-1.572.483z"
          ></path>
        </svg>
      </a>
    </div>
  </div>
</div>
